import React from 'react'
import SimpleBanner from '../Common/SimpleBanner'
import AboutUs_banner from '../../Assets/About/banaraimg.png'
import RangeOfServies from '../../Components/Services/RangeOfServices'
import SubscribeTo from '../../Components/home/SubscribeTo'
const Services = () => {
  return (
    <div className='overflow-x-hidden tracking-wide'>
     <SimpleBanner
        image={AboutUs_banner}
        name="Services"
        path="Home / Services"
      />
      
      <RangeOfServies/>
      <SubscribeTo/>
    </div>
  )
}

export default Services
